import { memo } from 'react';
import { View, type ViewProps } from 'react-native';

import { createMqStyles } from '../../mq-styles';
import { tokens } from '../../tokens';
import { Text } from '../text';

export type SectionListHeaderProps = ViewProps & {
  title: string;
};

export const SectionListHeader = memo((props: SectionListHeaderProps) => {
  const mqStyles = useMqStyles();

  if (!props.title) {
    return (
      <View
        {...props}
        accessible={false}
        accessibilityElementsHidden
        style={[mqStyles.sectionContainer, mqStyles.empty, props.style]}
      />
    );
  }

  return (
    <View
      {...props}
      accessibilityRole="header"
      accessibilityLabel={props.title}
      style={[mqStyles.sectionContainer, props.style]}
    >
      <Text.Heading accessible={false} importantForAccessibility="no" type="two">
        {props.title}
      </Text.Heading>
    </View>
  );
});

const useMqStyles = createMqStyles({
  empty: {
    $base: {
      height: 0,
      paddingTop: 0,
      marginTop: 0,
      marginBottom: 0,
    },
  },
  sectionContainer: {
    $base: {
      overflow: 'hidden',
      marginTop: 20,
      backgroundColor: tokens.colors.$white,
    },
    $gteDesktop: {
      marginTop: 44,
    },
  },
});
